(() => {
 function init(){
  document.querySelectorAll('[data-sm-carousel]').forEach(root=>{
   if(root.dataset.carouselReady==='1')return;
   root.dataset.carouselReady='1';
   const track=root.querySelector('[data-sm-carousel-track]');
   const prev=root.querySelector('[data-sm-prev]');
   const next=root.querySelector('[data-sm-next]');
   if(!track||!prev||!next)return;
   function update(){
    prev.disabled=track.scrollLeft<=2;
    next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;
   }
   function move(dir){
    const card=track.querySelector('.sm-album');
    const gap=parseFloat(getComputedStyle(track).gap)||0;
    const step=card?card.getBoundingClientRect().width+gap:track.clientWidth;
    track.scrollBy({left:dir*step,behavior:'smooth'});
   }
   prev.addEventListener('click',()=>move(-1));
   next.addEventListener('click',()=>move(1));
   track.addEventListener('scroll',update,{passive:true});
   window.addEventListener('resize',update);
   update();
  });
 }
 document.addEventListener('DOMContentLoaded',init);
 document.addEventListener('shopify:section:load',init);
 if(document.readyState!=='loading')init();
})();
